<template>
    <div>
        <div class="simple-row">
            <div class="left"></div>
            <div class="right">
                <a class="swb-btn swb-btn-small" v-if="!extracted" @click="getAssetDeprTestResult">刷新</a>
                <a class="swb-btn swb-btn-small" v-if="!extracted" @click="doAssetDeprTest">重新测试</a>
                <a class="swb-btn swb-btn-small" @click="doExport">导出</a>
            </div>
        </div>
        <div class="simple-form flex label col-3">
            <div class="form-group">
                <div class="form-label">
                    <label class="font14 Bold">测试公司数量</label>
                </div>
                <div class="form-value">
                    <span class="font14 Bold">{{realComCount}}</span>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label class="font14 Bold">产生折旧单数量</label>
                </div>
                <div class="form-value">
                    <span class="font14 Bold">{{formCount || 0}}</span>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label class="font14 Bold">折旧月份</label>
                </div>
                <div class="form-value">
                    <span class="font14 Bold">{{deprMonth || ''}}</span>
                </div>
            </div>
        </div>
        <div class="simple-form flex label col-3">
            <div class="form-group">
                <div class="form-label">
                    <label class="font14 Bold">测试通过数量</label>
                </div>
                <div class="form-value">
                    <span class="font14 Bold font-green">{{testResult.execPassCount}}</span>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label class="font14 Bold">测试中数量</label>
                </div>
                <div class="form-value">
                    <span class="font14 Bold">{{testResult.execOngoingCount}}</span>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label class="font14 Bold">测试失败数量</label>
                </div>
                <div class="form-value">
                    <span class="font14 Bold font-red">{{testResult.execFailCount}}</span>
                </div>
            </div>
        </div>
        <div class="mb10" style="border: 1px solid #ebebeb;padding: 10px;" v-for="assetDeprResult, index in assetDeprResultList">
            <div style="width: 40px;float: right;">
                <i class="icon iconfont icon-shanchu" style="cursor: pointer;font-size: 22px;color: #0c64eb" @click="doDel(index)" v-if="!extracted"></i>
            </div>
            <div class="simple-form flex label col-3">
                <div class="form-group">
                    <div class="form-label">
                        <label>公司名称</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetDeprResult.realComName || ''}}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>公司编码</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetDeprResult.realComCode || ''}}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>折旧月份</label>
                    </div>
                    <div class="form-value">
                        <span>{{deprMonth || ''}}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>测试结果</label>
                    </div>
                    <div class="form-value">
                        <span class="font-red" v-if="assetDeprResult.message != null && assetDeprResult.message != ''">{{assetDeprResult.message || ''}}</span>
                        <span v-else>{{assetDeprResult.execDesc || ''}}</span>
                    </div>
                </div>
            </div>
            <table class="custom-tbl mt10" v-if="assetDeprResult.message == null || assetDeprResult.message == ''">
                <thead class="head">
                <tr class="row align-left">
                    <th class="align-center">公司、利润中心、成本中心已配置</th>
                    <th style="width: 200px">财务类别、科目已配置</th>
                    <th style="width: 200px">满足折旧算法</th>
                    <th style="width: 200px">会计期间锁账状态</th>
                    <th style="width: 200px">系统接口对接配置</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row align-left">
                    <td class="align-center ellipsis">
                        <span class="font-green" v-if="assetDeprResult.hasCenterCode">正确</span>
                        <span class="font-red" v-else>异常</span>
                    </td>
                    <td style="width: 200px">
                        <span class="font-green" v-if="assetDeprResult.hasAssetKindSubject">正确</span>
                        <span class="font-red" v-else>异常</span>
                    </td>
                    <td style="width: 200px">
                        <span class="font-green" v-if="assetDeprResult.deprMethodAvaliable">正确</span>
                        <span class="font-red" v-else>异常</span>
                    </td>
                    <td style="width: 200px">
                        <span class="font-red" v-if="assetDeprResult.fiscalSealed">已锁账</span>
                        <span class="font-green" v-else>未锁账</span>
                    </td>
                    <td style="width: 200px">
                        <span class="font-green" v-if="assetDeprResult.jointSpotAvailable">正确</span>
                        <span class="font-red" v-else>异常</span>
                    </td>
                </tr>
                </tbody>
            </table>
            <table class="custom-tbl mt10" v-if="assetDeprResult.message == null || assetDeprResult.message == ''">
                <thead class="head">
                <tr class="row align-left">
                    <th>资产项目数量</th>
                    <th>可折旧资产项目数量</th>
                    <th>资产折旧计划数量</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row">
                    <td class="align-center">
                        <span class="fl ml5">{{assetDeprResult.assetsCount}}</span>
                        <!--<a class="swb-btn swb-btn-link fr mr15" @click="viewAsset(assetDeprResult, false)">查看明细</a>-->
                        <el-tag class="fr" style="cursor: pointer" type="" effect="dark" v-if="!extracted && parseInt(assetDeprResult.assetsCount || 0) > 0" @click="viewAsset(assetDeprResult, false)">
                            <span>查看明细</span>
                        </el-tag>
                    </td>
                    <td>
                        <span class="fl ml5">{{assetDeprResult.deprCount}}</span>
                        <!--<a class="swb-btn swb-btn-link fr mr15" @click="viewAsset(assetDeprResult, true)">查看明细</a>-->
                        <el-tag class="fr" style="cursor: pointer" type="" effect="dark" v-if="!extracted && parseInt(assetDeprResult.deprCount || 0) > 0" @click="viewAsset(assetDeprResult, true)">
                            <span>查看明细</span>
                        </el-tag>
                    </td>
                    <td>
                        <span class="fl ml5">{{assetDeprResult.deprPlanCount}}</span>
                        <!--<a class="swb-btn swb-btn-link fr mr15" @click="viewAssetDeprPlan(assetDeprResult, null)">查看明细</a>-->
                        <el-tag class="fr" style="cursor: pointer" type="" effect="dark" v-if="parseInt(assetDeprResult.deprPlanCount || 0) > 0" @click="viewAssetDeprPlan(assetDeprResult, null)">
                            <span>查看明细</span>
                        </el-tag>
                    </td>
                </tr>
                </tbody>
            </table>
            <table class="custom-tbl mt10" v-if="assetDeprResult.message == null || assetDeprResult.message == ''">
                <thead class="head">
                <tr class="row align-left">
                    <th>计划折旧金额(元)</th>
                    <th>实际折旧金额(元)</th>
                    <th>计划外折旧金额(元)</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row align-left">
                    <td class="align-right ellipsis">{{parseFloat(assetDeprResult.deprWorth || 0).toFixed(2)}}</td>
                    <td class="align-right">{{parseFloat(assetDeprResult.deprWorth2 || 0).toFixed(2)}}</td>
                    <td class="align-right">
                        <span class="mr10">{{parseFloat(assetDeprResult.deprExtraWorth || 0).toFixed(2)}}</span>
                        <el-tag style="cursor: pointer" type="" effect="dark" v-if="parseFloat(assetDeprResult.deprExtraWorth || 0) > 0" @click="viewAssetDeprPlan(assetDeprResult, true)">
                            <span>查看明细</span>
                        </el-tag>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import { showGrpDownloadDlg } from '../ctrl/dialog'
    import { shopDeviceAssetListDlg } from '../devc/selectDlg'
    import { openAssetDeprPlanItemListDlg } from './showDlg'

    import devcApi from '../../api/devc';
    import assetFiscalApi from '../../api/assetFiscal';

    export default {
        name: 'swb-asset-depr-result',
        props: {
            formId: {
                type: Number,
                default: null
            },
            realComCount: {
                type: Number,
                default: 0
            },
            deprMonth: {
                type: Number,
                default: null
            },
            extracted: {
                type: Boolean,
                default: false
            },
            assetDeprResultList: {
                type: Array,
                default: function () {
                    return [];
                }
            }
        },
        data: function () {
            return {
                formCount: 0,
                testResult: {
                    execOngoingCount: 0,
                    execPassCount: 0,
                    execFailCount: 0
                },
                execOngoing: getEnumInfoWith('taskState', 'name', 'Started').value,
                execPass: getEnumInfoWith('taskState', 'name', 'Finished').value,
                failed: getEnumInfoWith('taskState', 'name', 'Failed').value
            }
        },
        created: function () {
            let self = this;
            let assetDeprResultList = this.assetDeprResultList || [];
            let formCount = 0;
            let execOngoingCount = 0;
            for (let i = 0, len = assetDeprResultList.length; i < len; i++) {
                let assetDeprResult = assetDeprResultList[i];
                let formId = assetDeprResult.formId;
                if (!Utils.isNoB(formId) && parseInt(formId) > 0) {
                    formCount++;
                    execOngoingCount++;
                }
            }
            this.formCount = formCount;
            //
            let testResult = {execOngoingCount: execOngoingCount};
            this.testResult = Utils.merge({}, testResult);
            //
            this.getAssetDeprTestResult();
            // 定时器
            if (formCount > 0) {
                let time1 = setInterval(function () {
                    let execOngoingCount = self.testResult.execOngoingCount;
                    let execPassCount = self.testResult.execPassCount;
                    if (execPassCount > 0 && execOngoingCount <= 0) {
                        clearInterval(time1);
                    } else {
                        self.getAssetDeprTestResult();
                    }
                }, 300000);	// 300000 5分钟 刷新所有数据
            }
        },
        methods: {
            // 查看资产列表
            viewAsset: function (assetDeprResult, onlyQueryDeprAsset) {
                let params = {
                    realComId: assetDeprResult.realComId,
                    onlyShowRealCom: true,
                    onlyQueryDeprAsset: onlyQueryDeprAsset,
                    unFilterAuthx: true
                };
                if (Utils.isTrue(onlyQueryDeprAsset)) {
                    params.currentMonth = this.deprMonth;
                    params.onlyQueryDeprAsset = onlyQueryDeprAsset;
                    params.deprable = true;
                    params.excludeCnt1stMonth = true;
                    params.fiscalAbnormal = false;
                } else {
                    params.assetNature = getEnumInfoWith("assetNature", "name", "FIXED_ASSETS").value;
                }
                shopDeviceAssetListDlg(params);
            },
            // 拆看折旧计划列表，onlyExtraDepr 查询仅有计划外折旧的折旧计划
            viewAssetDeprPlan: function (assetDeprResult, onlyExtraDepr) {
                let params = {
                    formId: assetDeprResult.formId,
                    onlyExtraDepr: onlyExtraDepr
                };
                openAssetDeprPlanItemListDlg(params);
            },
            // 刷新
            getAssetDeprTestResult: function () {
                let self = this;
                //
                let execOngoing = this.execOngoing;
                let execPass = this.execPass;
                let failed = this.failed
                //
                if (!Utils.repeatChecker.isValidFor("getAssetDeprTestResult", 1000)) {
                    return;
                }
                let assetDeprResultList = this.assetDeprResultList || [];
                let realComIds = [];
                for (let i = 0, len = assetDeprResultList.length; i < len; i++) {
                    let assetDeprResult = assetDeprResultList[i];
                    let realComId = assetDeprResult.realComId;
                    if (!Utils.isNoB(realComId) && parseInt(realComId) > 0) {
                        if (!realComIds.contains(parseInt(realComId))) {
                            realComIds.push(parseInt(realComId));
                        }
                    }
                }
                //
                let postData = {
                    formId: self.formId || null,
                    realComIds: realComIds,
                    deprMonth: self.deprMonth
                };
                let theLoad = MsgBox.loading();
                assetFiscalApi.getAssetDeprFormDeprExecSnapList(postData, function (result) {
                    theLoad.hide();
                    if (result.type === "info") {
                        let resultList = result.data || [];
                        if (resultList != null && resultList.length > 0) {
                            //
                            let execOngoingCount = 0;
                            let execPassCount = 0;
                            let execFailCount = 0;
                            //
                            for (let i = 0, len = resultList.length; i < len; i++) {
                                let result = resultList[i];
                                let execState = result.execState;
                                if (execState != null) {
                                    if (execOngoing == execState) {
                                        execOngoingCount++;
                                    } else if (execPass == execState) {
                                        execPassCount++;
                                    } else if(failed == execState) {
                                        execFailCount++;
                                    }
                                }
                            }
                            //
                            let testResult = self.testResult;
                            testResult.execOngoingCount = execOngoingCount;
                            testResult.execPassCount = execPassCount;
                            testResult.execFailCount = execFailCount;
                            self.testResult = Utils.merge({}, testResult);
                        }
                        self.assetDeprResultList = resultList;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 重新测试
            doAssetDeprTest: function () {
                let self = this;
                if (!Utils.repeatChecker.isValidFor("doAssetDeprTest", 1000)) {
                    return;
                }
                let assetDeprResultList = this.assetDeprResultList || [];
                let realComIds = [];
                for (let i = 0, len = assetDeprResultList.length; i < len; i++) {
                    let assetDeprResult = assetDeprResultList[i];
                    //
                    let realComId = assetDeprResult.realComId;
                    if (!Utils.isNoB(realComId) && parseInt(realComId) > 0) {
                        if (!realComIds.contains(parseInt(realComId))) {
                            realComIds.push(parseInt(realComId));
                        }
                    }
                }
                this.$confirm('确定要重新测试吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    //
                    let postData = {
                        realComIds: realComIds,
                        deprMonth: self.deprMonth
                    };
                    let theLoad = MsgBox.loading();
                    devcApi.doAssetDeprTest(postData, function (result) {
                        theLoad.hide();
                        if (result.type === "info") {
                            self.assetDeprResultList = result.data || [];
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            // 导出
            doExport: function () {
                let self = this;
                if (!Utils.repeatChecker.isValidFor("doExport", 1000)) {
                    return;
                }
                let assetDeprResultList = this.assetDeprResultList || [];
                let realComIds = [];
                for (let i = 0, len = assetDeprResultList.length; i < len; i++) {
                    let assetDeprResult = assetDeprResultList[i];
                    let realComId = assetDeprResult.realComId;
                    if (!Utils.isNoB(realComId) && parseInt(realComId) > 0) {
                        if (!realComIds.contains(parseInt(realComId))) {
                            realComIds.push(parseInt(realComId));
                        }
                    }
                }
                let exportCols = [
                    {
                        "name": "realComName",
                        "title": "公司名称",
                        "width": 150,
                        "dataType": "string",
                        "align": "left",
                        "overflowAsTip": false,
                        "format": null,
                        "asTpl": false
                    }, {
                        "name": "realComCode",
                        "title": "公司编码",
                        "width": 80,
                        "dataType": "string",
                        "align": "center",
                        "overflowAsTip": false,
                        "format": null,
                        "asTpl": false
                    }, {
                        "name": "deprMonth",
                        "title": "折旧月份",
                        "width": 200,
                        "dataType": "string",
                        "align": "left",
                        "overflowAsTip": false,
                        "format": null,
                        "asTpl": false
                    }, {
                        "name": "messageX",
                        "title": "测试结果",
                        "width": 200,
                        "dataType": "string",
                        "align": "left",
                        "overflowAsTip": false,
                        "format": null,
                        "asTpl": false
                    }, {
                        "name": "hasCenterCode",
                        "title": "公司、利润中心、成本中心已配置",
                        "width": 200,
                        "dataType": "bool",
                        "align": "left",
                        "overflowAsTip": false,
                        "format": "正确/异常",
                        "asTpl": false
                    }, {
                        "name": "hasAssetKindSubject",
                        "title": "财务类别、科目已配置",
                        "width": 150,
                        "dataType": "bool",
                        "align": "left",
                        "overflowAsTip": false,
                        "format": "正确/异常",
                        "asTpl": false
                    }, {
                        "name": "deprMethodAvaliable",
                        "title": "满足折旧算法",
                        "width": 100,
                        "dataType": "bool",
                        "align": "left",
                        "overflowAsTip": false,
                        "format": "正确/异常",
                        "asTpl": false
                    }, {
                        "name": "fiscalSealed",
                        "title": "会计期间锁账状态",
                        "width": 100,
                        "dataType": "bool",
                        "align": "left",
                        "overflowAsTip": false,
                        "format": "已锁账/未锁账",
                        "asTpl": false
                    }, {
                        "name": "jointSpotAvailable",
                        "title": "系统接口对接配置",
                        "width": 100,
                        "dataType": "bool",
                        "align": "left",
                        "overflowAsTip": false,
                        "format": "正确/异常",
                        "asTpl": false
                    }, {
                        "name": "assetsCount",
                        "title": "资产项目数量",
                        "width": 100,
                        "dataType": "integer",
                        "align": "right",
                        "overflowAsTip": false,
                        "format": "",
                        "asTpl": false
                    }, {
                        "name": "deprCount",
                        "title": "可折旧资产项目数量",
                        "width": 100,
                        "dataType": "integer",
                        "align": "right",
                        "overflowAsTip": false,
                        "format": "",
                        "asTpl": false
                    }, {
                        "name": "deprPlanCount",
                        "title": "资产折旧计划数量",
                        "width": 100,
                        "dataType": "integer",
                        "align": "right",
                        "overflowAsTip": false,
                        "format": "",
                        "asTpl": false
                    }, {
                        "name": "deprWorth",
                        "title": "计划折旧金额(元)",
                        "width": 100,
                        "dataType": "float",
                        "align": "right",
                        "overflowAsTip": false,
                        "format": "0.00",
                        "asTpl": false
                    }, {
                        "name": "deprWorth2",
                        "title": "实际折旧金额(元)",
                        "width": 100,
                        "dataType": "float",
                        "align": "right",
                        "overflowAsTip": false,
                        "format": "0.00",
                        "asTpl": false
                    }, {
                        "name": "deprExtraWorth",
                        "title": "计划外折旧金额(元)",
                        "width": 100,
                        "dataType": "float",
                        "align": "right",
                        "overflowAsTip": false,
                        "format": "0.00",
                        "asTpl": false
                    }
                ];
                let tableData = {};
                tableData.rows = Utils.merge([], assetDeprResultList);
                tableData.cols = Utils.merge([], exportCols);
                //
                let pageSize = 2000;
                let pages = Math.ceil((assetDeprResultList || []).length / pageSize);
                if (pages > 10) {
                    showPageRangeSelDlg("选择导出文件序号", pages, 10, this.lastPageNumber, function (ok, range) {
                        if (ok) {
                            if (range.to == pages) {
                                self.lastPageNumber = 0;
                            } else {
                                self.lastPageNumber = range.to;
                            }
                            //
                            self.exportPrintData(pageSize, range.from, range.to, realComIds, tableData);
                        }
                    }, {pageSize: pageSize})
                } else {
                    self.exportPrintData(pageSize, null, null, realComIds, tableData);
                }
            },
            exportPrintData(pageSize, fromPages, toPages, realComIds, tableData){

                let pages = Math.ceil((this.assetDeprResultList || []).length / pageSize);
                //
                fromPages = fromPages == null ? 1 : fromPages;
                toPages = toPages == null ? pages : toPages;
                tableData = this.getTableData(pages, pageSize, realComIds, tableData);
                //
                let url = getAppUrl("/file/export/as/excel");
                let downloadUrls = [];
                for (let i = fromPages; i <= toPages; i++) {
                    let tmpFile = {};
                    tmpFile.url = url;
                    tmpFile.post = true;
                    tmpFile.fileName = "测试结果" + (pages == 1 ? '' : ("_" + (i)));
                    tmpFile.seqNo = i;
                    //
                    let data = Utils.merge({}, tableData);
                    data.pageNumber = i;
                    data.fileName = tmpFile.fileName;
                    tmpFile.data = data;
                    downloadUrls.push(tmpFile);
                }
                let title = '测试结果-下载 | 每个文件' + pageSize + '条数据';
                showGrpDownloadDlg(title, downloadUrls);
            },
            getTableData(pages, pageSize, realComIds, tableData){
                //
                let postData = {
                    filterItems: {
                        formId: this.formId || null,
                        realComIds: realComIds,
                        deprMonth: this.deprMonth
                    }
                };
                let rowsSrc = {};
                rowsSrc.data = postData;
                rowsSrc.url = "/asset/fiscal/asset/depr/form/deprExecSnap/paged/list/get";
                tableData.rowsSrc = rowsSrc;
                tableData.pageSize = pageSize;
                tableData.pageCount = (this.assetDeprResultList || []).length;
                tableData.pages = pages;
                //
                return tableData;
            },
            // 移除
            doDel: function (index) {
                let assetDeprResultList = this.assetDeprResultList || [];
                for (let i = 0, len = assetDeprResultList.length; i < len; i++) {
                    if (i == index) {
                        assetDeprResultList.splice(i, 1);
                        break;
                    }
                }
                //
                let realComCount = 0;
                let formCount = 0;
                for (let i = 0, len = assetDeprResultList.length; i < len; i++) {
                    let assetDeprResult = assetDeprResultList[i];
                    let formId = assetDeprResult.formId;
                    if (!Utils.isNoB(formId) && parseInt(formId) > 0) {
                        formCount++;
                    }
                    let realComId = assetDeprResult.realComId;
                    if (!Utils.isNoB(realComId) && parseInt(realComId) > 0) {
                        realComCount++;
                    }
                }
                this.formCount = formCount;
                this.realComCount = realComCount;
                this.assetDeprResultList = Utils.merge([], assetDeprResultList);
            },
            // 计提并关闭
            getDlgResult: function () {
                if (!Utils.repeatChecker.isValidFor("getDlgResult", 1000)) {
                    return;
                }
                let assetDeprResultList = this.assetDeprResultList || [];
                let allRealComIds = assetDeprResultList.pluck('realComId');
                let realComIds = [];
                let errMsg = '';
                for (let i = 0, len = assetDeprResultList.length; i < len; i++) {
                    let assetDeprResult = assetDeprResultList[i];
                    if (!Utils.isNoB(assetDeprResult.message)) {
                        errMsg = '公司【' + assetDeprResult.realComCode + '】' + assetDeprResult.message;
                        continue;
                    }
                    if (assetDeprResult.execDesc == "测试中") {
                        errMsg = '公司【' + assetDeprResult.realComCode + '】未测试通过，不能进行折旧计提，请刷新！';
                        continue;
                    }
                    //
                    let realComId = assetDeprResult.realComId;
                    if (!Utils.isNoB(realComId) && parseInt(realComId) > 0) {
                        if (!Utils.isTrue(assetDeprResult.hasCenterCode)) {
                            errMsg = '公司【' + assetDeprResult.realComCode + '】资产利润中心、成本中心配置异常，不能进行折旧计提！';
                            continue;
                        }
                        if (!Utils.isTrue(assetDeprResult.hasAssetKindSubject)) {
                            errMsg = '公司【' + assetDeprResult.realComCode + '】资产财务类别、科目配置异常，不能进行折旧计提！';
                            continue;
                        }
                        if (!Utils.isTrue(assetDeprResult.deprMethodAvaliable)) {
                            errMsg = '公司【' + assetDeprResult.realComCode + '】资产不满足折旧算法，不能进行折旧计提！';
                            continue;
                        }
                        if (Utils.isTrue(assetDeprResult.fiscalSealed)) {
                            errMsg = '公司【' + assetDeprResult.realComCode + '】会计期间锁账，不能进行折旧计提！';
                            continue;
                        }
                        if (!Utils.isTrue(assetDeprResult.jointSpotAvailable)) {
                            errMsg = '公司【' + assetDeprResult.realComCode + '】系统接口对接配置异常，不能进行折旧计提！';
                            continue;
                        }
                        realComIds.push(parseInt(realComId));
                    }
                }
                //
                let result = {};
                if (Utils.isNoB(allRealComIds) || allRealComIds.length <= 0) {
                    result.type = 'warn';
                    result.message = '请选择要计提的公司';
                    return result;
                }
                let msg = '';
                if (realComIds.length > 0) {
                    if (realComIds.length != allRealComIds.length) {
                        msg = '有' + (allRealComIds.length - realComIds.length) + '家公司不能折旧计提,是否继续?';
                    } else {
                        msg = '确定要进行折旧计提吗?';
                    }
                } else {
                    result.type = 'warn';
                    result.message = '选择的实体公司都不能折旧计提';
                    return result;
                }
                //
                result.type = 'info';
                result.msg = msg;
                result.data = {
                    realComIds: realComIds,
                    deprMonth: this.deprMonth
                };
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/assetDepr/AssetDeprResult.vue